// extracted by mini-css-extract-plugin
module.exports = {"imageCropping":"style_imageCropping__2qOXk"};